const PrivateRoutes = [
  '/ajuda',
  '/contratos',
  '/boletim_web/public/boletins',
  '/banco_de_dados',
  '/banco_de_dados/acompanhamentos',
  '/documentos',
  '/minhas_licitacoes/management',
  '/minhas_licitacoes/management/',
  '/minhas_licitacoes/configuracoes',
  '/facilitadores/monitoramento',
  '/facilitadores/trading_keywords',
  '/painel',
  '/waranty_phrases',
  '/ata_de_registro_preco',
  '/iminencia',
  '/finalizar_assinatura',
  '/planos',
  '/contato',
  '/compra_finalizada',
  '/compra_realizada',
  '/solicitar_edital',
  '/checkout',
  '/editar_contato',
  '/robo_lance',
  '/meu_historico',
  '/assinatura_digital',
  '/dr_licita',
  '/dr_licita/document',
  '/cadastrar',
  '/robo_dashboard',
  '/minha_conta',
  '/curso',
  '/mercado',
  '/conteudo_exclusivo',
  '/concorrentes',
  '/assessoria_cadastral',
  '/programa_de_integridade',
  '/conlicitacao_api',
  '/conlicita_go',
  '/tools_status',
  '/juridico',
  '/legislacao',
  '/consultoria_juridica',
  '/cadastro',
  '/conlicitantes',
  '/usuarios/password/',
  '/facilitadores/robo',
  '/biddings',
  '/minhas_licitacoes/shares',
  '/modelos-documentos',
  '/notification/notifications',
  '/usuarios/invitation/accept',
  '/usuarios/recurso_expirado',
  '/boletim_web/public/boletins/:boletin_id/biddings/:id',
  '/monitoring_quoted',
  '/recurso_inativo',
  '/assinatura_vencida',
  '/assinatura_paralisada',
  '/renovacao',
  '/renovacao_email',
  '/portais',
  '/palestra',
  '/concorrente',
  '/conlicitaseg',
  '/validar_contrato',
  '/manutencao',
  '/central_ia',
  '/academy',
  '/embaixadores',
  '/pesquisa_de_precos',
  '/gestao_ia',
  '/representante',
  '/representacao',
  '/conlicitaseg/only-onboarding',
];

export default PrivateRoutes;
